import { Navigate } from 'react-router';
import { useCurrentUser } from '../../../shared/features/session/components/CurrentUserProvider';
import { useOrganization } from '../../../shared/features/organization/components/OrganizationProvider';
import { TenantLogo } from '../../../shared/features/organization/components/TenantLogo';
import { ColorModeToggle } from '../../../shared/features/theme/components/ColorModeToggle';
import { LoginBrandPanel } from '../components/LoginBrandPanel';
import { LoginCodeForm } from '../components/LoginCodeForm';
import { LoginNewPasswordForm } from '../components/LoginNewPasswordForm';
import { LoginPasswordForm } from '../components/LoginPasswordForm';
import { useLoginPage } from '../hooks/use-login-page';

export function LoginPage() {
  const { state } = useCurrentUser();
  const organization = useOrganization();
  const { step, error, submitting, submitPassword, submitNewPassword, codeStep } = useLoginPage();

  // An already-authenticated visit (back button, bookmarked /login) should land on the app, not the form.
  if (state.status === 'authenticated') return <Navigate to="/" replace />;

  return (
    <div className="grid min-h-screen bg-surface lg:grid-cols-[minmax(0,5fr)_minmax(0,6fr)]">
      <LoginBrandPanel />
      <main className="relative flex items-center justify-center px-6 py-12">
        <div className="absolute top-5 right-5">
          <ColorModeToggle />
        </div>
        <div className="w-full max-w-sm">
          <div className="mb-10 lg:hidden">
            <TenantLogo size="login" />
          </div>
          {step === 'password' && (
            <LoginPasswordForm
              title={organization.configured ? `Sign in to ${organization.name}` : 'Sign in'}
              error={error}
              submitting={submitting}
              onSubmit={submitPassword}
            />
          )}
          {step === 'newPassword' && <LoginNewPasswordForm error={error} submitting={submitting} onSubmit={submitNewPassword} />}
          {step === 'code' && <LoginCodeForm step={codeStep} />}
        </div>
      </main>
    </div>
  );
}
